import React, { useState } from "react";
import { Link } from "react-router-dom";
import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";
import { Table, Skeleton } from "antd"; // Updated import
import FeatherIcon from "feather-icons-react/build/FeatherIcon";
import { onShowSizeChange, itemRender } from "../../components/Pagination";
import { hooks } from "../../studentportal-sdk";
import CourseSidebar from "../../components/SideBar/CourseSidebar";
import SideBar from "../../components/SideBar/AdminSideBar";


const Users = (props) => {
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);

  const onSelectChange = (newSelectedRowKeys) => {
    console.log("selectedRowKeys changed: ", newSelectedRowKeys);
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  const columns = [
    {
      title: "ID",
      dataIndex: "id",
      sorter: (a, b) => a.StudentId.length - b.StudentId.length,
    },
    {
      title: "Name",
      dataIndex: "firstname",
      sorter: (a, b) => a.Name.length - b.Name.length,
      // render: (text, record) => (
      //   <h2 className="table-avatar">
      //     <Link to="/viewusers" className="avatar avatar-sm me-2 ">
      //       <img
      //         className="avatar-img rounded-circle"
      //         src={record.Img}
      //         alt="User Image"
      //       />
      //     </Link>
      //     <Link className="text-dark" to="/viewusers">
      //       {record.Name}
      //     </Link>
      //   </h2>
      // ),
    },
    {
      title: "E-mail",
      dataIndex: "email",
      sorter: (a, b) => a.email.length - b.email.length,
    },
    {
      title: "Role",
      dataIndex: "role",
      sorter: (a, b) => a.role.length - b.role.length,
    },
    {
      title: "Role",
      dataIndex: "role",
      sorter: (a, b) => a.Class.length - b.Class.length,
    },
    // {
    //   title: "DOB",
    //   dataIndex: "DOB",
    //   sorter: (a, b) => a.DOB.length - b.DOB.length,
    // },
    {
      title: "Group Name",
      dataIndex: "group",
      sorter: (a, b) => a.ParentName.length - b.ParentName.length,
    },
    {
      title: "Mobile Number",
      dataIndex: "phone",
      sorter: (a, b) => a.phone.length - b.phone.length,
    },

    {
      title: "Action",
      dataIndex: "Action",
      render: (text, record) => (
        <div className="actions">
          <Link to="#" className="btn btn-sm bg-success-light me-2">
            <i className="feather-eye">
              <FeatherIcon icon="eye" />
            </i>
          </Link>
          <Link to="/editstudent" className="btn btn-sm bg-danger-light">
            <i className="feather-edit">
              <FeatherIcon icon="edit" className="list-edit" />
            </i>
          </Link>
        </div>
      ),
    },
  ];

  const {
    userService:{
      store: { users, loading }
    }
  } = props

  const role = localStorage.getItem('role')

  return (
    <>
      <div className="main-wrapper">
        {/* Header */}
        <Header />
        {/* Sidebar */}
        {role === "admin" && <SideBar />}
 {role === "user" &&  <CourseSidebar />}

        {/* Page Wrapper */}
        <div className="page-wrapper">
          <div className="content container-fluid">
            {/* Page Header  */}
            <div className="page-header">
              <div className="row">
                <div className="col-sm-12">
                  <div className="page-sub-header">
                    <h3 className="page-title">Users</h3>
                    <ul className="breadcrumb">
                      <li className="breadcrumb-item">
                        <Link to="/Users">User</Link>
                      </li>
                      <li className="breadcrumb-item active">All Users</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            {/* Search Form */}
            <div className="student-group-form">
              <div className="row">
                <div className="col-lg-3 col-md-6">
                  <div className="form-group">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Search by ID ..."
                    />
                  </div>
                </div>
                <div className="col-lg-3 col-md-6">
                  <div className="form-group">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Search by Name ..."
                    />
                  </div>
                </div>
                <div className="col-lg-4 col-md-6">
                  <div className="form-group">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Search by Phone ..."
                    />
                  </div>
                </div>
                <div className="col-lg-2">
                  <div className="search-student-btn">
                    <button type="button" className="btn btn-primary">
                      Search
                    </button>
                  </div>
                </div>
              </div>
            </div>
            {/* Users Table */}
            <div className="row">
              <div className="col-sm-12">
                <div className="card card-table comman-shadow">
                  <div className="card-body">
                    {/* Page Header */}
                    <div className="page-header">
                      <div className="row align-items-center">
                        <div className="col">
                          <h3 className="page-title">Users</h3>
                        </div>
                        <div className="col-auto text-end float-end ms-auto download-grp">
                          <Link
                            to="/users"
                            className="btn btn-outline-gray me-2 active"
                          >
                            <FeatherIcon className="feather-list" icon="list" />
                          </Link>
                          <Link
                            to="/usergrid"
                            className="btn btn-outline-gray me-2"
                          >
                            <FeatherIcon className="feather-grid" icon="grid" />
                          </Link>
                          <Link to="#" className="btn btn-outline-primary me-2">
                            <i className="fas fa-download" /> Download
                          </Link>
                          <Link to="/addadmin" className="btn btn-primary">
                            <i className="fas fa-plus" />
                          </Link>
                        </div>
                      </div>
                    </div>
                    <div className="table-responsive">
                      {/* Optional: Skeleton Placeholder */}
                      {loading.active ? (
                        <Skeleton active paragraph={{ rows: 10 }} />
                      ) : (
                        <Table
                          loading={loading.active}
                          locale={{
                            emptyText: "No users found. Please add new users.",
                          }}
                          pagination={{
                            total: users?.length,
                            showTotal: (total, range) =>
                              `Showing ${range[0]} to ${range[1]} of ${total} entries`,
                            showSizeChanger: true,
                            onShowSizeChange: onShowSizeChange,
                            itemRender: itemRender,
                          }}
                          columns={columns}
                          dataSource={users}
                          rowSelection={rowSelection}
                          rowKey={(record) => record.Id}
                        />
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
        {/* /Page Wrapper */}
      </div>
      {/* /Main Wrapper */}
    </>
  );
};

/* eslint-disable */
export default (props) => <Users {...hooks.UserManagement(props)} />; 
